import PartTwo from './PartTwo';
import FindKeypadIntro from './FindKeypadIntro';
import FindKeypad from './FindKeypad';
import KeypadGameSlide2 from './KeypadGameSlide2';
import KeypadGameIntro from './KeypadGameIntro';
import KeypadGameOutro from './KeypadGameOutro';

export default [PartTwo, FindKeypadIntro, FindKeypad, KeypadGameIntro, KeypadGameSlide2, KeypadGameOutro];
